// extracted by mini-css-extract-plugin
module.exports = {"boxFrame":"style_boxFrame__6_sX4"};